import HourGlass from './HourGlassTheme';

export default HourGlass;
